// ServiceCardsSection.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ConsultationModal from './ConsultationModal';

const ServiceCardsSection = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  const services = [
    {
      tag: 'Education',
      title: 'Study Abroad Support',
      description: 'University shortlisting, application preparation, and admission support to help you secure your place at top institutions abroad.',
      link: '/study-abroad',
      cta: 'Explore Study Programs',
      color: 'blue'
    },
    {
      tag: 'Employment',
      title: 'Work Abroad Opportunities',
      description: 'Access verified employers, guaranteed interviews for eligible candidates, and comprehensive preparation for overseas employment.',
      link: '/work-abroad',
      cta: 'Explore Work Opportunities',
      color: 'red'
    },
    {
      tag: 'Assessment',
      title: 'Consultation & Eligibility',
      description: 'Personalized consultation to assess your background, goals, and eligibility for the most suitable study or work pathway.',
      action: 'consultation',
      cta: 'Book Consultation',
      color: 'yellow'
    },
    {
      tag: 'Preparation',
      title: 'Application & Interview Support',
      description: 'Document preparation, interview coaching, and structured guidance to ensure strong, well-prepared applications.',
      action: 'consultation',
      cta: 'Get Support',
      color: 'green'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      red: 'border-t-red-500',
      yellow: 'border-t-yellow-500',
      green: 'border-t-green-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  const getSquareColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-500',
      red: 'bg-red-500',
      yellow: 'bg-yellow-500',
      green: 'bg-green-500'
    };
    return colors[color] || 'bg-blue-500';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Service Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`bg-[#F5F8FA] p-8 border-t-2 ${getColorClasses(service.color)} hover:shadow-lg transition-shadow`}
            >
              <div className="flex items-center gap-2 mb-6">
                <span className={`w-2 h-2 ${getSquareColorClasses(service.color)}`}></span>
                <span className="text-sm font-normal text-gray-600">
                  {service.tag}
                </span>
              </div>
              
              <h3 className="text-xl font-semibold text-[#202356] mb-4 leading-tight">
                {service.title}
              </h3>
              
              <p className="text-gray-600 text-sm font-light leading-relaxed mb-8">
                {service.description}
              </p>
              
              {service.link ? (
                <Link 
                  to={service.link}
                  className="text-[#202356] text-sm font-normal hover:underline inline-block border-b border-[#202356] pb-1"
                >
                  {service.cta}
                </Link>
              ) : (
                <button
                  onClick={() => setShowConsultationModal(true)}
                  className="text-[#202356] text-sm font-normal hover:underline inline-block border-b border-[#202356] pb-1"
                >
                  {service.cta}
                </button>
              )}
            </motion.div>
          ))}
        </div>
      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal}
        onClose={() => setShowConsultationModal(false)}
        serviceType="general"
      />
    </section>
  );
};

export default ServiceCardsSection;
